import { useMutation, useQueryClient } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'
import { useUser } from '../user/useUser'
import { optimisticUpdate } from '../util/optimisticUpdate'
import { EVENTS_QUERY_KEY } from './useEvents'
import { USER_RSVPS_QUERY_KEY } from './useUserRSVPs'

type UserRSVP = Awaited<ReturnType<typeof dataSource.getUserEvents>>[number]

export const RSVP_RESPONSE = "RSVP'd"

export function useRSVPEvent() {
  const queryClient = useQueryClient()
  const { data: user } = useUser()
  const challengeId = useChallengeId()

  return useMutation({
    mutationFn: async (eventID: string) => {
      if (!user) throw new Error('User must be logged in to RSVP')
      await dataSource.saveUserEvent(user.id, eventID, RSVP_RESPONSE)
    },
    ...optimisticUpdate<UserRSVP[], string>(
      queryClient,
      USER_RSVPS_QUERY_KEY(user?.id ?? ''),
      (current, eventID) => [...current, { eventID, response: RSVP_RESPONSE }],
    ),
    onSuccess: () => {
      if (challengeId) {
        queryClient.invalidateQueries({ queryKey: EVENTS_QUERY_KEY(challengeId) })
      }
    },
  })
}
